<template>
  <ac-modal :title="'Edit Member Information'" ref="modalRef">
    <template>
      <form v-if="widgetReady">
        <div class="row" style="margin-top: 12px;">
          <div class="col-xs-8 col-xs-offset-4">
            <label>Social Security Number</label>
            <small v-if="vm.ssnRequired">&nbsp;<span class="redText">required</span></small>
          </div>
          <div class="col-lg-4">
            <h4>
              <span>{{ vm.consumer.firstName }}</span>
              <span>{{ vm.consumer.middleInitial }}</span>
              <span>{{ vm.consumer.lastName }}</span>
            </h4>
          </div>
          <div class="col-lg-4">
            <ac-social-security-number v-model="vm.consumer.ssn"></ac-social-security-number>
          </div>
          <div class="col-lg-4">
            <ac-button class="btn btn-green btn-sm" :action="()=>{update(vm.consumer)}">UPDATE</ac-button>
          </div>
        </div>
        <div class="row" style="margin-top: 10px; margin-bottom: 10px;" v-for="dependent in vm.dependents">
          <div class="col-xs-8 col-lg-offset-4">
            <label>Social Security Number</label>
            <small v-if="vm.ssnRequired">&nbsp;<span class="redText">required</span></small>
          </div>
          <div class="col-lg-4">
            <h5>
              <span>{{ dependent.firstName }}</span>
              <span>{{ dependent.middleInitial }}</span>
              <span>{{ dependent.lastName }}</span>
            </h5>
          </div>
          <div class="col-lg-4">
            <ac-social-security-number v-model="dependent.ssn"/>
          </div>
          <div class="col-lg-4">
            <ac-button class="btn btn-green btn-sm" :action="()=>{update(dependent)}">UPDATE</ac-button>
          </div>
        </div>
        <!-- /ko -->
      </form>
    </template>
    <template slot="buttons">
      <ac-button class="btn btn-red btn-sm" :action="closeModal">CLOSE</ac-button>
    </template>
  </ac-modal>
</template>

<script>
import {api} from "../../../global/framework/api.js";

export default {
  name: "EditEmployeeModal",
  data() {
    return {
      widgetReady: false,
      vm: {}
    }
  },
  methods: {
    async update(consumer) {
      let result = api.post("Company", "UpdateEmployeeInfo", consumer);
      if (result) {
        this.closeModal();
      }
    },
    async showModal({companyId, consumerId}) {
      let data = await api.getDataWithTwoIds("Company", companyId, "GetEditEmployeeInfoModel", consumerId);
      this.mapData('vm', data);
      this.widgetReady = true;
      this.$refs.modalRef.open();
    },
    closeModal() {
      this.$refs.modalRef.close();
    }
  }
}
</script>

<style scoped>

</style>